export const timeRangeSessionKey = 'timeInterval';
export const paLocationSessionKey = 'filter_edge_location';
export const scopeSelectionSessionKey = 'platform_type';

export function clearSessionStorage() {
  [timeRangeSessionKey, paLocationSessionKey, scopeSelectionSessionKey].forEach(
    (key) => sessionStorage.removeItem(key)
  );
}
